const getFirstPageSizeFromMarkers = (markers, defaultItemsPerPage) => {
  const soldOutPropertiesPresent = markers.filter(m => m.so);

  return soldOutPropertiesPresent.length > 0
    ? defaultItemsPerPage + soldOutPropertiesPresent.length
    : defaultItemsPerPage;
};

const DEFAULT_INITIAL_PAGE = 1;

class SimplifiedCardPaginator {
  constructor(opts = {}) {
    this.pageSize = opts.pageSize;
    this.currentPage = opts.initialPage;
    this.numberOfMarkers = opts.numberOfMarkers || 0;
    this.totalMarkers = opts.numberOfMarkers || 0;
    this.firstPageSize = getFirstPageSizeFromMarkers(
      opts.initialMarkers || [],
      this.pageSize
    );
  }

  // We are expecting the marker list because we need to count with the SO properties present in the list.
  updateData = ({ markers, nTotalMarkers }) => {
    this.numberOfMarkers = markers.length;
    this.totalMarkers = nTotalMarkers;
    this.firstPageSize = getFirstPageSizeFromMarkers(markers, this.pageSize);
    this.validateCurrentPage();
  };

  getTotalPages = () => {
    if (this.totalMarkers === 0) {
      return 0;
    }

    if (this.totalMarkers <= this.firstPageSize) {
      return 1;
    }

    const remaining = this.totalMarkers - this.firstPageSize;
    return 1 + Math.ceil(remaining / this.pageSize);
  };

  validateCurrentPage = () => {
    if (this.getTotalPages() < this.currentPage) {
      this.currentPage = 1;
    }
  };

  setCurrentPage = page => {
    this.currentPage = page || DEFAULT_INITIAL_PAGE;
  };
  getCurrentPageNumber = () => this.currentPage;
  hasPrevPage = () => this.currentPage > 1;
  hasNextPage = () => this.currentPage < this.getTotalPages();
  getNextPageNumber = () => (this.hasNextPage() ? this.currentPage + 1 : null);
  getPreviousPageNumber = () =>
    this.hasPrevPage() ? this.currentPage - 1 : null;
  getLength = () => this.numberOfMarkers;
  getTotalMarkers = () => this.totalMarkers;
  // results hidden by filtering in the map by boundaries
  hasHiddenResults = () =>
    this.numberOfMarkers < this.pageSize &&
    this.totalMarkers > this.numberOfMarkers;
  getPageSize = () => this.pageSize;
}

export default SimplifiedCardPaginator;
